import AddonVariant from "src/api/graphql/__generated__/enums/AddonVariant";
import { AddonFragmentFragment } from "src/api/graphql/__generated__/graphql";
import parseUrlForLabel from "src/helpers/addonHelpers/helpers/parseUrlForLabel";
import { MiniCardProps } from "../types";
import MiniCardAppleMusicDefaultProps from "../variants/MiniCardAppleMusicDefaultProps";
import MiniCardLinkDefaultProps from "../variants/MiniCardLinkDefaultProps";
import MiniCardLocationDefaultProps from "../variants/MiniCardLocationDefaultProps";
import MiniCardSpotifyDefaultProps from "../variants/MiniCardSpotifyDefaultProps";
import MiniCardVenmoDefaultProps from "../variants/MiniCardVenmoDefaultProps";

const parseAddonVariantToDefaultProps = (
	variant: AddonVariant | null | undefined,
): Partial<MiniCardProps> => {
	switch (variant) {
		case AddonVariant.Spotify:
			return MiniCardSpotifyDefaultProps;
		case AddonVariant.Location:
			return MiniCardLocationDefaultProps;
		case AddonVariant.Venmo:
			return MiniCardVenmoDefaultProps;
		case AddonVariant.AppleMusic:
			return MiniCardAppleMusicDefaultProps;
		case AddonVariant.Link:
		default:
			return MiniCardLinkDefaultProps;
	}
};

const checkIsValidUrl = (url: string): boolean => {
	try {
		new URL(url);
		return true;
	} catch (e) {
		return false;
	}
};

const parseAddonToMiniCard = (addon: Partial<AddonFragmentFragment>) => {
	const label =
		!addon.label && addon.url
			? parseUrlForLabel({
					url: addon.url,
					variant: addon.variant ?? undefined,
				})
			: addon.label;
	const initialDefaultProps = parseAddonVariantToDefaultProps(addon.variant);
	const shouldDisplayAddonCopyModal = Boolean(addon.url && !checkIsValidUrl(addon.url));
	const title = label ?? initialDefaultProps.title;
	const defaultProps = {
		...initialDefaultProps,
		target: "_blank",
		title,
		href: shouldDisplayAddonCopyModal ? undefined : (addon.url ?? undefined),
		content: addon.icon
			? {
					variant: "Image",
					alt: "Icon",
					src: addon.icon,
				}
			: initialDefaultProps.content,
		fallbackContent: addon.icon ? initialDefaultProps.content : undefined,
	} satisfies Partial<MiniCardProps>;

	return {
		defaultProps,
		shouldDisplayAddonCopyModal,
	};
};
export default parseAddonToMiniCard;
